export default () => {
    const gallery = document.querySelectorAll('.logo-carousel__items');

    for (const el of gallery) {
        const children = el.querySelectorAll('.logo-carousel__item');

        if (children.length) {
            el.style.setProperty('--animation-duration', children.length * 3 + 's');
        }
    }
};
